'use client'

import { useMemo } from 'react'
import { useLogger } from 'next-axiom'
import type { SafeNextAxiomLogFields, SafeNextAxiomLogger } from './next-axiom'
import { createSafeNextAxiomLoggerFromLogger } from './next-axiom'

const EMPTY_FIELDS: SafeNextAxiomLogFields = {}

export function useSafeNextAxiomLogger(
  baseFields: SafeNextAxiomLogFields = EMPTY_FIELDS,
): SafeNextAxiomLogger {
  const logger = useLogger({ source: 'handled-platform-app-client' })

  return useMemo(
    () => createSafeNextAxiomLoggerFromLogger(logger, baseFields),
    [logger, baseFields],
  )
}
